import log from 'salvo-lite/log'

class ScrollClass {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            class: 'fixed',
            maxWidth: 9999999999,
            ...JSON.parse(elem.getAttribute('data-scroll-class') || '{}')
        }
        this._headerHeight = document.querySelector('.site-header').offsetHeight
        this._distanceFromTop = window.pageYOffset + this._elem.getBoundingClientRect().top
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        // update distancefromtop when images have loaded
        document.querySelector('.product__images [data-preload]').addEventListener('preload-complete', () => {
            this._distanceFromTop = window.pageYOffset + this._elem.getBoundingClientRect().top
        })
        if (window.innerWidth <= this._data.maxWidth) {
            this._classLogic()
            window.addEventListener('scroll', () => this._classLogic())
        }
    }

    _classLogic () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        if (scrollTop >= this._distanceFromTop - this._headerHeight) {
            !this._elem.classList.contains(this._data.class) && this._elem.classList.add(this._data.class)
        } else {
            this._elem.classList.contains(this._data.class) && this._elem.classList.remove(this._data.class)
        }
    }
}

export default ScrollClass



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ScrollClass.js